export default __webpack_public_path__ + "static/media/investors.f87c920e.svg";